<template>
  <div>
    <div
      class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">Menú General</div>
      <v-spacer/>
      <v-btn
        rounded
        small
        depressed
        color="primary"
        class="mr-3"
        @click="export2pdf">
        Exportar como PDF
      </v-btn>
      <v-btn
        v-if="restaurant.picture"
        rounded
        small
        depressed
        color="primary"
        @click="download">
        Descargar logo
      </v-btn>
    </div>

    <v-flex xs12>
      <v-card outlined tile>
        <v-card-text v-if="isLoading">
          <div
            v-for="text in 15"
            :key="`text-${text}`"
            class="mb-5 d-flex justify-space-between">
            <v-skeleton-loader
              height="15px"
              min-width="200px"
              type="text"
            />
            <v-skeleton-loader
              height="15px"
              min-width="50px"
              type="text"
            />
          </div>
        </v-card-text>
        <v-card-text v-else ref="menu">
          <div class="black--text">
            <div>
              <div v-if="restaurant.picture">
                <img ref="logo" class="logo" :src="restaurant.picture.location" alt="" srcset="">
              </div>
              <div v-else>
                {{ restaurant.name }}
              </div>
            </div>
            <div
              v-for="(section, index) in sectionsList"
              :key="`section-${index}`"
              class="mb-5">
              <div class="title mb-2">
                {{ section.name }}
              </div>
              <div>
                <div
                  v-for="(recipe, i) in section.children"
                  :key="`recipe-${index}-${i}`"
                  class="d-flex justify-space-between mb-2"
                  style="display: flex">
                    <div>
                      <div>
                        {{ recipe.name }}
                      </div>
                      <div class="grey--text">
                        {{ recipe.description }}
                      </div>
                    </div>
                    <div v-if="recipe.price > 0">
                      {{ recipe.price | toFixNumber | numberWithComma | prefix('$') }}
                    </div>
                    <div v-else>
                      {{ recipe.price | toFixNumber | numberWithComma | prefix('$') }} - Gratis
                    </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import Section from '@/models/Section'
import JsPdf from 'jspdf'

export default {
  name: 'Menu',
  data () {
    let section = new Section()

    return {
      sectionModel: section,
      sectionsList: [],
      isLoading: false
    }
  },
  watch: {
    '$store.state.currentRestaurant.data': async function (val) {
      await this.load()
    }
  },
  computed: {
    restaurant: function () {
      return this.$store.state.currentRestaurant.data
    }
  },
  mounted: async function () {
    await this.load()
  },
  methods: {
    async load (params = null) {
      this.isLoading = true
      try {
        const response = await this.$api.get(`/v1/menu`)
        this.sectionsList = response.map(x => ({
          id: x.id,
          name: x.name,
          children: x.recipes.map(y => ({
            id: y.uuid,
            recipe: true,
            ...y
          }))
        }))
      } catch (error) {
        if (error.response.response.data.length <= 0) {
          // ignore toast
        } else {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      }
      this.isLoading = false
    },
    export2pdf: async function () {
      const doc = new JsPdf({
        orientation: 'p',
        format: 'letter',
        unit: 'pt'
      })
      const totalSections = this.sectionsList.length - 1
      var x = 20
      var y = 40
      // if (this.restaurant.picture) {
      //   const type = this.restaurant.picture.name.split('.')[1]
      //   const img = await this.getDataUrl()
      //   doc.addImage(img, type, x, y, 150, 150)
      // }
      doc.setFontSize(30)
      doc.setFont('helvetica', 'bold')
      doc.text(this.restaurant.name, x, y)
      doc.setFont('helvetica', 'normal')
      y += 30
      this.sectionsList.forEach((section, index) => {
        doc.setFontSize(18)
        doc.text(section.name, x, y)
        y += 30
        section.children.forEach(recipe => {
          if (y >= doc.internal.pageSize.height - 30) {
            doc.addPage()
            y = 40
          }
          doc.setFontSize(12)
          doc.text(recipe.name, x, y, { maxWidth: 450 })
          doc.text(`$${Number(recipe.price).toFixed(2)}`, x + 500, y, { align: 'right' })
          if (recipe.description) {
            doc.setFontSize(10)
            doc.setTextColor('#9e9e9e')
            doc.text(recipe.description, x, y + 12, { maxWidth: 450 })
          }
          doc.setTextColor('#000000')
          y += 35
        })
        if (index < totalSections) {
          doc.addPage()
        }
        y = 40
      })
      doc.save(`menu-${this.restaurant.name}.pdf`)
    },
    getDataUrl: async function () {
      const url = this.restaurant.picture.location
      const resp = await fetch(url, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      const blob = await resp.blob()
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onerror = reject
        reader.onloadend = () => resolve(reader.result)
      })
    },
    download () {
      const link = document.createElement('a')
      link.href = this.restaurant.picture.location
      link.download = this.restaurant.name
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  max-width: 150px;
  max-height: 150px;
}
</style>
